<script>
export default {
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
}
</script>
<template>
  <div class="base-checkbox">
    <input
      id="checkbox"
      v-model="checked"
      type="checkbox"
      v-on="$listeners">
    <label
      v-if="label"
      class="base-checkbox__label"
      for="checkbox">{{ label }}</label>

  </div>
</template>

<style lang="scss" module>
@import '@design';

.base-checkbox {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;

  &__label {
    margin-bottom: 0;
  }
}

input[type='checkbox'] {
  transform: scale(1.5);
}
</style>
